import { type CoachApiClient, createCoachApi } from "@coach/api-client";
import { getBearerToken } from "./auth-client";

const baseUrl = import.meta.env.VITE_PUBLIC_API_URL ?? "http://localhost:28780";

let cached: CoachApiClient | null = null;
export function api(): CoachApiClient {
  if (!cached) cached = createCoachApi({ baseUrl, getAuthToken: () => getBearerToken() });
  return cached;
}

/** Direct fetch escape hatch for endpoints not yet on the typed client. */
export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const token = getBearerToken();
  const res = await fetch(`${baseUrl}${path}`, {
    credentials: "include",
    ...init,
    headers: {
      "content-type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(init?.headers as Record<string, string> | undefined),
    },
  });
  if (!res.ok) {
    const body = await res.text().catch(() => "");
    throw new Error(`${init?.method ?? "GET"} ${path} → ${res.status} ${body}`);
  }
  return (await res.json()) as T;
}
